import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { AddressFormComponent } from 'src/app/shared/components/address-form/address-form.component';
import { AddressComponent } from 'src/app/shared/components/address/address.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AmgGeoModule } from '../amg-geo/amg-geo.module';
import { AddressComponentV2 } from './address/address.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    AmgGeoModule,
  ],
  declarations: [AddressComponent, AddressFormComponent, AddressComponentV2],
  exports: [AddressComponent, AddressFormComponent, AddressComponentV2],
})
export class AmgAddressModule {}
